<div [class.state-failed]="isFailed" [class.state-loading]="isLoading" [class.state-success]="isSuccess" class="screen">
	<!-- ── Status pill ── -->
	<div class="status-label">
		@if (isLoading) {
			<div class="status-dot"></div>
			<div class="status-text">{{ 'topgolfAnimation.processing' | translate }}</div>
		}
		@if (isSuccess) {
			<div class="status-dot success-dot"></div>
			<div class="status-text success-text">{{ 'topgolfAnimation.success' | translate }}</div>
		}
		@if (isFailed) {
			<div class="status-dot failed-dot"></div>
			<div class="status-text failed-text">{{ 'topgolfAnimation.failed' | translate }}</div>
		}
	</div>

	<!-- ══ GOLF BALL ══ -->
	<div class="ball-stage">
		@if (isLoading) {
			<div class="p-ring"></div>
			<div class="p-ring"></div>
			<div class="p-ring"></div>
		}

		<svg class="ball-svg" viewBox="0 0 196 196" xmlns="http://www.w3.org/2000/svg">
			<defs>
				<!-- Realistic ball gradient -->
				<radialGradient cx="32%" cy="24%" id="bG" r="68%">
					<stop offset="0%" stop-color="#FFFFFF" />
					<stop offset="30%" stop-color="#F4F4F2" />
					<stop offset="70%" stop-color="#D8D8D4" />
					<stop offset="100%" stop-color="#A4A49E" />
				</radialGradient>
				<!-- Ambient shadow on bottom-right -->
				<radialGradient cx="70%" cy="72%" id="shadeG" r="55%">
					<stop offset="0%" stop-color="#606058" stop-opacity="0.35" />
					<stop offset="100%" stop-color="#606058" stop-opacity="0" />
				</radialGradient>
				<!-- Blue inner glow for spinner -->
				<radialGradient cx="50%" cy="50%" id="igG">
					<stop offset="0%" stop-color="#004FFE" stop-opacity="0.28" />
					<stop offset="100%" stop-color="#004FFE" stop-opacity="0" />
				</radialGradient>
				<!-- Green inner glow for success -->
				<radialGradient cx="50%" cy="50%" id="igGreen">
					<stop offset="0%" stop-color="#00C853" stop-opacity="0.28" />
					<stop offset="100%" stop-color="#00C853" stop-opacity="0" />
				</radialGradient>
				<!-- Red inner glow for failed -->
				<radialGradient cx="50%" cy="50%" id="igRed">
					<stop offset="0%" stop-color="#F44336" stop-opacity="0.28" />
					<stop offset="100%" stop-color="#F44336" stop-opacity="0" />
				</radialGradient>
				<!-- Arc gradient -->
				<linearGradient gradientUnits="userSpaceOnUse" id="arcG" x1="98" x2="98" y1="30" y2="98">
					<stop offset="0%" stop-color="#004FFE" stop-opacity="0" />
					<stop offset="100%" stop-color="#004FFE" stop-opacity="1" />
				</linearGradient>
				<clipPath id="bc">
					<circle cx="98" cy="98" r="76" />
				</clipPath>
			</defs>

			<!-- Ball base -->
			<circle cx="98" cy="98" fill="url(#bG)" r="78" />
			<!-- Ambient shading layer -->
			<circle cx="98" cy="98" fill="url(#shadeG)" r="78" />

			<!-- ── DIMPLES ── -->
			<g clip-path="url(#bc)" fill="rgba(0,0,0,0.13)">
				<circle cx="98" cy="36" r="2.2" />
				<circle cx="84" cy="43" r="2.2" />
				<circle cx="112" cy="43" r="2.2" />
				<circle cx="71" cy="53" r="2.2" />
				<circle cx="98" cy="51" r="2.2" />
				<circle cx="125" cy="53" r="2.2" />
				<circle cx="58" cy="64" r="2.3" />
				<circle cx="77" cy="62" r="2.3" />
				<circle cx="98" cy="64" r="2.3" />
				<circle cx="119" cy="62" r="2.3" />
				<circle cx="138" cy="64" r="2.3" />
				<circle cx="46" cy="77" r="2.3" />
				<circle cx="65" cy="75" r="2.3" />
				<circle cx="83" cy="77" r="2.3" />
				<circle cx="98" cy="77" r="2.3" />
				<circle cx="113" cy="77" r="2.3" />
				<circle cx="131" cy="75" r="2.3" />
				<circle cx="150" cy="77" r="2.3" />
				<circle cx="35" cy="93" r="2.3" />
				<circle cx="52" cy="90" r="2.3" />
				<circle cx="70" cy="92" r="2.3" />
				<circle cx="126" cy="92" r="2.3" />
				<circle cx="144" cy="90" r="2.3" />
				<circle cx="161" cy="93" r="2.3" />
				<circle cx="40" cy="108" r="2.3" />
				<circle cx="58" cy="110" r="2.3" />
				<circle cx="76" cy="108" r="2.3" />
				<circle cx="98" cy="110" r="2.3" />
				<circle cx="120" cy="108" r="2.3" />
				<circle cx="138" cy="110" r="2.3" />
				<circle cx="156" cy="108" r="2.3" />
				<circle cx="50" cy="122" r="2.3" />
				<circle cx="68" cy="124" r="2.3" />
				<circle cx="86" cy="122" r="2.3" />
				<circle cx="110" cy="122" r="2.3" />
				<circle cx="128" cy="124" r="2.3" />
				<circle cx="146" cy="122" r="2.3" />
				<circle cx="60" cy="136" r="2.2" />
				<circle cx="78" cy="138" r="2.2" />
				<circle cx="98" cy="139" r="2.2" />
				<circle cx="118" cy="138" r="2.2" />
				<circle cx="136" cy="136" r="2.2" />
				<circle cx="71" cy="150" r="2.1" />
				<circle cx="87" cy="153" r="2.1" />
				<circle cx="109" cy="153" r="2.1" />
				<circle cx="125" cy="150" r="2.1" />
				<circle cx="84" cy="163" r="2" />
				<circle cx="98" cy="165" r="2" />
				<circle cx="112" cy="163" r="2" />
				<circle cx="44" cy="116" r="2.2" />
				<circle cx="152" cy="116" r="2.2" />
				<circle cx="57" cy="130" r="2.1" />
				<circle cx="139" cy="130" r="2.1" />
			</g>

			<!-- Inner glow — state dependent -->
			@if (isLoading) {
				<circle class="inner-glow" clip-path="url(#bc)" cx="98" cy="98" fill="url(#igG)" r="52" />
			}
			@if (isSuccess) {
				<circle class="inner-glow" clip-path="url(#bc)" cx="98" cy="98" fill="url(#igGreen)" r="52" />
			}
			@if (isFailed) {
				<circle class="inner-glow" clip-path="url(#bc)" cx="98" cy="98" fill="url(#igRed)" r="52" />
			}

			<!-- ── Spinner (loading only) ── -->
			@if (isLoading) {
				<g clip-path="url(#bc)">
					<circle class="arc-track" cx="98" cy="98" fill="none" r="68" stroke="white" stroke-width="5.5" />
					<circle
						class="arc-spin"
						cx="98"
						cy="98"
						fill="none"
						r="68"
						stroke="url(#arcG)"
						stroke-dasharray="427.3"
						stroke-dashoffset="95"
						stroke-linecap="round"
						stroke-width="5.5"
					/>
					<circle
						class="arc-spin"
						cx="98"
						cy="98"
						fill="none"
						r="68"
						stroke="#004FFE"
						stroke-dasharray="427.3"
						stroke-dashoffset="422"
						stroke-linecap="round"
						stroke-width="6"
					/>
					<circle
						class="arc-tip"
						cx="98"
						cy="30"
						fill="#004FFE"
						r="6"
						style="filter: drop-shadow(0 0 7px rgba(0, 79, 254, 0.95))"
					/>
				</g>
			}

			<!-- ── Center icon ── -->
			<g class="pay-icon">
				@if (isLoading) {
					<text
						fill="rgba(15,15,15,0.55)"
						font-family="'Barlow Condensed', sans-serif"
						font-size="34"
						font-weight="700"
						text-anchor="middle"
						x="98"
						y="106"
					>
						€
					</text>
				}
				@if (isSuccess) {
					<text
						fill="rgba(0,200,83,0.85)"
						font-family="'Barlow Condensed', sans-serif"
						font-size="42"
						font-weight="700"
						text-anchor="middle"
						x="98"
						y="108"
					>
						✓
					</text>
				}
				@if (isFailed) {
					<text
						fill="rgba(244,67,54,0.85)"
						font-family="'Barlow Condensed', sans-serif"
						font-size="42"
						font-weight="700"
						text-anchor="middle"
						x="98"
						y="108"
					>
						✕
					</text>
				}
			</g>

			<!-- Specular highlights -->
			<ellipse cx="70" cy="60" fill="rgba(255,255,255,0.52)" rx="18" ry="11" transform="rotate(-28 70 60)" />
			<ellipse cx="63" cy="55" fill="rgba(255,255,255,0.72)" rx="7" ry="4" transform="rotate(-28 63 55)" />
			<circle cx="60" cy="52" fill="rgba(255,255,255,0.85)" r="3" />
		</svg>

		<!-- Orbit (loading only) -->
		@if (isLoading) {
			<div class="orbit"></div>
		}
	</div>
	<!-- /ball-stage -->

	<!-- ── Heading ── -->
	<div class="payment-heading">
		@if (isLoading) {
			<p class="sub">{{ 'topgolfAnimation.pleaseWait' | translate }}<br />{{ 'topgolfAnimation.processingSafe' | translate }}</p>
		}
		@if (isSuccess) {
			<p class="sub success-sub">{{ 'topgolfAnimation.successMessage' | translate }}</p>
		}
		@if (isFailed) {
			<p class="sub failed-sub">{{ message || ('topgolfAnimation.failedMessage' | translate) }}</p>
		}
	</div>

	<div class="rule-red"></div>

	<!-- ── Steps ── -->
	<div class="steps">
		<div class="step done">
			<div class="step-dot"><span class="s-check">✓</span></div>
			<span class="step-name">{{ 'topgolfAnimation.stepOrdered' | translate }}</span>
		</div>
		<div class="step done">
			<div class="step-dot"><span class="s-check">✓</span></div>
			<span class="step-name">{{ 'topgolfAnimation.stepAuthorized' | translate }}</span>
		</div>
		<div [class.active]="isLoading" [class.done]="isSuccess" [class.failed-step]="isFailed" class="step">
			<div class="step-dot">
				@if (isLoading) {
					<div class="s-ring"></div>
				}
				@if (isSuccess) {
					<span class="s-check">✓</span>
				}
				@if (isFailed) {
					<span class="s-check s-fail">✕</span>
				}
			</div>
			<span class="step-name">{{ 'topgolfAnimation.stepPayment' | translate }}</span>
		</div>
		<div [class.done]="isSuccess" class="step">
			<div class="step-dot">
				@if (isSuccess) {
					<span class="s-check">✓</span>
				}
			</div>
			<span class="step-name">{{ 'topgolfAnimation.stepDone' | translate }}</span>
		</div>
	</div>

	<!-- ── Security ── -->
	<div class="security-row">
		<span style="font-size: 13px">🔒</span>
		<span class="security-text">{{ 'topgolfAnimation.secure' | translate }}</span>
	</div>
</div>
